import gql from 'graphql-tag';

export const deliveryLayoutFragment = gql`
  fragment DeliveryLocationFields on DeliveryLocation {
    id
    name
    capacity
  }
`;

export const deliveryCategoryFragment = gql`
  fragment DeliveryCategoryFields on DeliveryCategory {
    id
    adminName
    children {
      ...DeliveryLocationFields
    }
  }
  ${deliveryLayoutFragment}
`;

export const deliveryLayoutResponseFragment = gql`
  fragment DeliveryLayoutResponseFields on DeliveryLayoutResponse {
    category {
      ...DeliveryCategoryFields
    }
    parents {
      ...DeliveryLocationFields
    }
  }
  ${deliveryLayoutFragment}
  ${deliveryLayoutFragment}
`;

export const serverAssignmentsFragment = gql`
  fragment ServerAssignmentFields on ServerAssignments {
    server {
      id
      name
    }
    assignments {
      id
      location {
        ...DeliveryLocationFields
      }
      parents {
        ...DeliveryLocationFields
      }
    }
  }
  ${deliveryLayoutFragment}
`;
